import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import NavBar from './components/NavBar';
import Home from './pages/Home';
import ServiceDetail from './pages/ServiceDetail';
import Footer from './components/Footer';
import MobileCTA from './components/MobileCTA';
import AdminDashboard from './components/Admin/AdminDashboard';
import PrivateRoute from './components/Admin/PrivateRoute';
import NotFound from './pages/NotFound';
import SplashScreen from './components/SplashScreen';

import './App.css';

/* ページ遷移・ハッシュリンクのスクロール制御 */
function ScrollManager() {
  const { pathname, hash } = useLocation();

  React.useEffect(() => {
    if (hash) {
      // レンダリング完了を待ってからアンカーへスクロール
      const timer = setTimeout(() => {
        document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth' });
      }, 80);
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);

  return null;
}

function AppContent() {
  const location = useLocation();
  // スプラッシュはセッション初回のみ表示（毎回のブロックを防ぐ）
  const [loading, setLoading] = React.useState(
    () => !sessionStorage.getItem('pd-splash-shown')
  );

  React.useEffect(() => {
    if (!loading) return undefined;
    const timer = setTimeout(() => {
      sessionStorage.setItem('pd-splash-shown', '1');
      setLoading(false);
    }, 1600);
    return () => clearTimeout(timer);
  }, [loading]);

  if (loading) {
    return <SplashScreen />;
  }

  const isAdmin = location.pathname === '/admin';

  return (
    <>
      {!isAdmin && <NavBar />}
      <ScrollManager />
      <div className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          {/* サービス詳細（データ駆動の共通テンプレート） */}
          <Route path="/services/:slug" element={<ServiceDetail />} />
          {/* 管理者ダッシュボード */}
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      {!isAdmin && <Footer />}
      {!isAdmin && <MobileCTA />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
